<div id="appCapsule" style="padding-bottom: 0;">
    <router-outlet (activate)="onActivate()"></router-outlet>
</div>